module.exports = __webpack_public_path__ + "static/thg-logo-9134b46acd736e96cef3032440bf2d67.png";